module.exports = __webpack_public_path__ + "static/DPOrganizer-a85c3f7222a5300796b8631a5da14ddf.jpg";